import { useState, useEffect } from 'react';

interface ResponsiveState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  scaleFactor: number;
  width: number;
  height: number;
}

export const useResponsive = (): ResponsiveState => {
  const [state, setState] = useState<ResponsiveState>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    scaleFactor: 1,
    width: typeof window !== 'undefined' ? window.innerWidth : 1920,
    height: typeof window !== 'undefined' ? window.innerHeight : 1080
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      // Updated breakpoints for modern mobile devices
      const isMobile = width < 900; // Increased from 768 to better handle modern mobile screens
      const isTablet = width >= 900 && width < 1200; // Adjusted tablet breakpoint
      const isDesktop = width >= 1200;
      
      // Calculate scale factor based on screen size
      let scaleFactor = 1;
      
      if (isMobile) {
        // More granular scale factor for mobile
        if (width < 400) {
          scaleFactor = 0.6;
        } else if (width < 600) {
          scaleFactor = 0.7;
        } else {
          scaleFactor = 0.8;
        }
      } else if (isTablet) {
        scaleFactor = 0.85;
      }
      
      setState({
        isMobile,
        isTablet,
        isDesktop,
        scaleFactor,
        width,
        height
      });
    };

    // Set initial state
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return state;
}; 